import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import type { FightDeath } from "../model/FightDeath";
import { fightMomentText } from "./fightMomentText";

type FightDeathMomentsProps = {
  moments: readonly FightDeath[];
};

// Смерти в невыгодных драках списком: время, сколько своих против скольких врагов и как
// долго, иконки врагов рядом. Общая часть `DiedOutnumbered` и `DiedAlone`.
export const FightDeathMoments = ({ moments }: FightDeathMomentsProps) => {
  const { i18n } = useLingui();
  const findHero = useAssetLookup("heroes");
  return (
    <ul className="mt-1 flex flex-col gap-1.5 text-xs text-muted">
      {moments.map((moment) => (
        <li key={moment.time_s} className="flex flex-wrap items-center gap-2">
          <span>{fightMomentText(moment, i18n)}</span>
          <span className="flex gap-1">
            {moment.enemy_hero_ids.map(findHero).map((hero) => (
              <AssetIcon key={hero.id} asset={hero} size={24} className="rounded-md" />
            ))}
          </span>
        </li>
      ))}
    </ul>
  );
};
